import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const PRESONNEL_FIELD_NAME = 'personnelCode';
const PERSONNEL_CODE_MAX_LENGTH = 255;

export type PersonnelCodeFormBeanPart = { [PRESONNEL_FIELD_NAME]: string | null };

type PersonnelCodeFieldProps = Pick<FormContextValues<PersonnelCodeFormBeanPart>, 'register'> & {
   required: boolean;
};

export const PersonnelCodeField = (props: PersonnelCodeFieldProps): JSX.Element => {
   const controller = props.register(PRESONNEL_FIELD_NAME, {
      required: props.required,
      maxLength: PERSONNEL_CODE_MAX_LENGTH,
   });

   return <TextInput label={nfzLoginTranslationKeys.personnelCode} controller={controller} testId={'personnelCode'} />;
};
